var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMistake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM3.5 12a8.5 8.5 0 1 0 17 0 8.5 8.5 0 0 0-17 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.637 13.498a.5.5 0 0 1-.5.488h-.444a.5.5 0 0 1-.5-.488L11.06 7.51a.5.5 0 0 1 .5-.511h.718a.5.5 0 0 1 .5.512l-.14 5.986ZM11 16.122c0-.258.084-.471.252-.639.167-.172.396-.258.687-.258.29 0 .52.086.687.258.168.168.252.38.252.64 0 .249-.082.457-.245.625-.164.168-.395.252-.694.252-.3 0-.53-.084-.694-.252a.862.862 0 0 1-.245-.626Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistake);
export default __webpack_public_path__ + "static/media/Mistake.6c7d3ff8abbe031234e0d21c5ddeebff.svg";
export { ForwardRef as ReactComponent };